/* eslint-disable quotes */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Table, Spin, Button, Modal, Form, message, Tag, Switch } from "antd";
import "./daList.scss";
import urls from "../../../api/urls";
import axios from "axios";
import CreateDAForm from "../CreateDAForm";
import constants from "../../../constants/constants";
import API from "../../../api";

const { DA_BY_DP, ONBOARD_DA } = urls;
const { ROLES } = constants;
const { DP_OPERATOR, CP_ADMIN, CP_OPERATOR } = ROLES;

const DAList = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(0);
  const userinfo = JSON.parse(localStorage.getItem("userinfo"));
  const [originalTotal, setOriginalTotal] = useState();
  const [dataSource, setdataSource] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [isHistoryModalVisible, setIsHistoryModalVisible] = useState(false);
  const [orderHistory, setOrderHistory] = useState(null);
  const [selectedDA, setSelectedDA] = useState(null);
  const [historyLoading, setHistoryLoading] = useState(false);

  useEffect(() => {
    getTableData();
  }, []);

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const getTableData = async (p1 = 10, p2 = 0, customParams) => {
    try {
      setLoading(true);
      let queryParams;
      if (customParams) {
        queryParams = customParams;
      } else {
        queryParams = new URLSearchParams({
          page: (p2 + 1).toString(),
          limit: p1.toString(),
        });
      }

      // Add id and role based on user role
      const roles = userinfo?.roles || [];
      const userRole = userinfo?.roles?.[0];
      const deliveryPartners =
        JSON.parse(sessionStorage.getItem("deliveryPartner"))?.data || [];
      const dpId = deliveryPartners.length > 0 ? deliveryPartners[0]?.dpId : "";
      queryParams.append("role", userRole);

      if (roles.includes(CP_ADMIN) || roles.includes(CP_OPERATOR)) {
        if (userinfo?.spId) queryParams.append("id", userinfo.spId);
      } else if (roles.includes(DP_OPERATOR)) {
        if (dpId) queryParams.append("id", dpId);
      }

      // Get the user token from localStorage
      const userToken = userinfo?.accessToken;

      if (!userToken) {
        message.error("No user token available");
        return;
      }

      // Use direct axios call which we've confirmed works
      const response = await axios.get(
        `${DA_BY_DP}?${queryParams.toString()}`,
        {
          headers: {
            kid: "1",
            authtype: "jwt",
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data) {
        setTotal(response.data?.totalRecords || response.data?.length || 0);
        setOriginalTotal(
          response.data?.totalRecords || response.data?.length || 0
        );

        const formattedData = Array.isArray(response.data.data)
          ? response.data.data
          : Array.isArray(response.data)
          ? response.data
          : [];

        setTableData(formattedData);
        setdataSource(formattedData);
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Failed to fetch DA list"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderHistory = async (daId) => {
    setIsHistoryModalVisible(true);
    try {
      setHistoryLoading(true);
      // Get the user token from localStorage
      const userToken = userinfo?.accessToken;
      if (!userToken) {
        message.error("Authentication token not found. Please log in again.");
        setHistoryLoading(false);
        return;
      }
      // Replace this URL and params with your actual endpoint for DA order history
      // Example: using GET_ORDER_BY_STATUS with deliveryAgentId as a filter
      const response = await axios.get(
        `${urls.CASH_DEPOSIT_ORDERS_BY_DA}/${daId}`,
        {
          headers: {
            kid: "1",
            authtype: "jwt",
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response?.data?.data) {
        setOrderHistory(response?.data?.data);
      } else {
        setOrderHistory(null);
        message.error("No order history found for this DA.");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Failed to fetch order history"
      );
      setIsHistoryModalVisible(false);
    } finally {
      setHistoryLoading(false);
    }
  };

  const showHistoryModal = (record) => {
    setSelectedDA(record);
    fetchOrderHistory(record?.deliveryAgentId);
  };

  const handleToggleDAStatus = async (deliveryAgentId, isActive) => {
    try {
      const res = await API.Api(urls.DA_TOGGLE_ACTIVE_STATUS).patch({
        deliveryAgentId: parseInt(deliveryAgentId),
        isActive,
      });
      const success =
        res?.status === true ||
        res?.response?.status === 200 ||
        res?.response?.data?.status === 200;
      if (success) {
        const successMsg =
          res?.response?.data?.message ||
          res?.message ||
          res?.data?.message ||
          `DA status updated to ${isActive ? "Active" : "Inactive"}`;
        message.success(successMsg);
        getTableData();
        // setTableData((prev) => prev.map((row) =>
        //   row.deliveryAgentId === deliveryAgentId ? { ...row, isActive } : row
        // ));
      } else {
        const apiMessage =
          res?.response?.data?.message || res?.message || res?.data?.message;
        message.error(apiMessage || "Failed to update DA status");
      }
    } catch (err) {
      const apiMessage = err?.response?.data?.message || err?.message;
      message.error(apiMessage || "Failed to update DA status");
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "deliveryAgentId",
      key: "deliveryAgentId",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (value, record) =>
        `${record?.name || ""} ${record?.lastName || ""}`,
    },
    {
      title: "Mobile Number",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Cash In Hand",
      dataIndex: "cashInHand",
      key: "cashInHand",
      render: (cashInHand) => (cashInHand ? cashInHand : "N/A"),
      align: "center",
    },
  ];

  if (userinfo && userinfo.roles && userinfo.roles.includes(DP_OPERATOR)) {
    columns.push({
      title: "COD History",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Button type="link" onClick={() => showHistoryModal(record)}>
          View History
        </Button>
      ),
    });
  }

  columns.push({
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <Tag color={status ? "green" : "red"}>
        {status ? "Active" : "Inactive"}
      </Tag>
    ),
  });

  columns.push({
    title: "Action",
    dataIndex: "status",
    key: "action",
    render: (isActive, record) => (
      <Switch
        checked={!!isActive}
        onChange={async (checked) =>
          handleToggleDAStatus(record.deliveryAgentId, isActive)
        }
      />
    ),
  });

  const handlePageChange = (pagination) => {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    getTableData(pagination.pageSize, pagination.current - 1);
  };

  const showModal = () => {
    setIsModalVisible(true);
    form.resetFields();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);

      // Get the DP ID from the logged-in user
      const deliveryPartners =
        JSON.parse(sessionStorage.getItem("deliveryPartner"))?.data || [];
      const dpId = deliveryPartners.length > 0 ? deliveryPartners[0]?.dpId : "";
      const userRole = userinfo?.roles?.[0];

      // Prepare the data for submission based on the API requirements
      const formData = {
        firstName: values.firstName,
        lastName: values.lastName,
        mobile: values.mobile,
        dpId: parseInt(dpId),
        spId: userinfo?.spId,
        role: userRole,
      };

      // Get the user token
      const userToken = userinfo?.accessToken;

      if (!userToken) {
        message.error("Authentication token not found. Please log in again.");
        setSubmitting(false);
        return;
      }

      try {
        // Make the actual API call
        const response = await axios.post(ONBOARD_DA, formData, {
          headers: {
            kid: "1",
            authtype: "jwt",
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        });

        if (response?.data) {
          message.success(
            response?.data?.message || "Delivery Agent created successfully"
          );
          setIsModalVisible(false);
          // Refetch the data after successful creation
          getTableData(pageSize, pageNum);
        } else {
          message.error(
            response?.data?.message || "Failed to create Delivery Agent"
          );
        }
      } catch (apiError) {
        message.error(
          apiError?.response?.data?.message || "Failed to create Delivery Agent"
        );
      } finally {
        setSubmitting(false);
        form.resetFields();
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Failed to create Delivery Agent"
      );
      setSubmitting(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <div className="master-main-container m-1 p-1">
        <div style={{ marginBottom: "16px", textAlign: "right" }}>
          <Button type="primary" onClick={showModal}>
            Create Delivery Agent
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={tableData}
          pagination={{
            pageSize: pageSize,
            itemRender: itemRender,
            total: total,
            current: pageNum === 0 ? 1 : pageNum,
          }}
          onChange={handlePageChange}
          rowKey={(record) =>
            record.deliveryAgentId || Math.random().toString()
          }
        />

        <Modal
          title="Create Delivery Agent"
          open={isModalVisible}
          onCancel={handleCancel}
          footer={[
            <Button key="back" onClick={handleCancel}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={submitting}
              onClick={handleSubmit}
            >
              Create
            </Button>,
          ]}
          width={600}
        >
          <CreateDAForm form={form} />
        </Modal>

        <Modal
          title={`Order History - ${selectedDA?.name || ""} ${
            selectedDA?.lastName || ""
          }`}
          open={isHistoryModalVisible}
          onCancel={() => {
            setIsHistoryModalVisible(false);
            setOrderHistory(null);
            setSelectedDA(null);
          }}
          footer={[
            <Button
              key="close"
              onClick={() => {
                setIsHistoryModalVisible(false);
                setOrderHistory(null);
                setSelectedDA(null);
              }}
            >
              Close
            </Button>,
          ]}
          width={1200}
        >
          <Spin spinning={historyLoading}>
            {orderHistory && (
              <div>
                <div
                  style={{
                    marginBottom: "20px",
                    padding: "16px",
                    background: "#fafafa",
                    borderRadius: "8px",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-around" }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <div
                        style={{
                          fontSize: "16px",
                          color: "#666",
                          marginBottom: "4px",
                        }}
                      >
                        Cash in Hand
                      </div>
                      <div
                        style={{
                          fontSize: "24px",
                          fontWeight: "bold",
                          color: "#52c41a",
                        }}
                      >
                        ₹{selectedDA?.cashInHand || 0}
                      </div>
                    </div>
                    {/* <div style={{ textAlign: "center" }}>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#666",
                          marginBottom: "4px",
                        }}
                      >
                        Outstanding Amount
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#ff4d4f",
                        }}
                      >
                        ₹{Math.abs(orderHistory?.otherAmount)?.toFixed(2) || 0}
                      </div>
                    </div> */}
                  </div>
                </div>
                <Table
                  dataSource={orderHistory?.orderData}
                  rowKey="_id"
                  pagination={{
                    pageSize: 5,
                    showSizeChanger: false,
                    showTotal: (total) => `Total ${total} items`,
                  }}
                  scroll={{ x: true }}
                  columns={[
                    {
                      title: "AWB Number",
                      dataIndex: "awbNumber",
                      key: "awbNumber",
                      width: 120,
                    },
                    {
                      title: "Order ID",
                      dataIndex: "originalOrderId",
                      key: "originalOrderId",
                      width: 120,
                    },
                    {
                      title: "Amount",
                      dataIndex: "amount",
                      key: "amount",
                      width: 100,
                      render: (amount) => `₹${amount?.toFixed(2) || 0}`,
                    },
                    {
                      title: "Weight",
                      dataIndex: "weight",
                      key: "weight",
                      width: 100,
                      render: (weight) => `${weight}g`,
                    },
                    {
                      title: "DA to Center Status",
                      dataIndex: [
                        "codCollectionHistory",
                        "daToCenterDepositStatus",
                      ],
                      key: "daToCenterStatus",
                      width: 150,
                      render: (status) => (
                        <Tag
                          color={
                            status === "DEBITED"
                              ? "green"
                              : status === "PENDING"
                              ? "orange"
                              : status === "INITIATED"
                              ? "blue"
                              : "default"
                          }
                        >
                          {status || "N/A"}
                        </Tag>
                      ),
                    },
                    {
                      title: "Center to Delcaper Status",
                      dataIndex: [
                        "codCollectionHistory",
                        "centerToDelcaperDepositStatus",
                      ],
                      key: "centerToDelcaperStatus",
                      width: 180,
                      render: (status) => (
                        <Tag
                          color={
                            status === "PENDING"
                              ? "orange"
                              : status === "INITIATED"
                              ? "blue"
                              : status === "DEBITED"
                              ? "green"
                              : "default"
                          }
                        >
                          {status || "N/A"}
                        </Tag>
                      ),
                    },
                    {
                      title: "Settled On",
                      dataIndex: ["codCollectionHistory", "daSettledOn"],
                      key: "daSettledOn",
                      width: 180,
                      render: (date) =>
                        date ? new Date(date).toLocaleString() : "N/A",
                    },
                    {
                      title: "Order Created",
                      dataIndex: "orderCreatedAt",
                      key: "orderCreatedAt",
                      width: 180,
                      render: (date) => new Date(date).toLocaleString(),
                    },
                    {
                      title: "Seller Info",
                      dataIndex: "sellerInfo",
                      key: "sellerInfo",
                      width: 200,
                      render: (seller) => (
                        <div>
                          <div>
                            <strong>{seller.name}</strong>
                          </div>
                          <div>{seller.companyName}</div>
                          <div>{seller.mobile}</div>
                        </div>
                      ),
                    },
                  ]}
                />
              </div>
            )}
          </Spin>
        </Modal>
      </div>
    </Spin>
  );
};

export default DAList;
